﻿(function () {
    'use strict';
    var controllerId = 'headercontroller';
    var appConf = angular.module('app.config');

    angular.module('app.controllers')
        .controller(controllerId, headerController);

    headerController.$inject = ['$location', '$scope', 'common', 'datacontext', 'localStorageService', '$rootScope', '$window', '$state', 'exDialog', 'idleService','geolocationService'];

    function headerController($location, $scope, common, datacontext, localStorageService, $rootScope, $window, $state, exDialog, idleService, geolocationService) {
        var vm = this;
        vm.logOut = logOut;
        vm.changePassword = changePassword;
        vm.changeyard = changeyard;
        vm.booksOnLine = getBooksOnLine;

        init();

        
        function init() {
            common.logger.debug('init');
            setUserData();
            common.localStorageService.set('fromLoginWindow', false);
            getAlerts();

            geolocationService.init();

            // Callback para la inactividad
            $scope.onIdleTimeout = function() {
                logOut();
            };
            
            idleService.init($scope.onIdleTimeout);

            // Limpiar el servicio cuando el controlador sea destruido
            $scope.$on('$destroy', function() {
                idleService.destroy();
            });
  
        }

        function logOut() {            
            datacontext.auth.logOut(true);
            window.location.reload(true);
        }

        function changePassword($event) {
            $location.path('/changepassword');
        }

        function changeyard(newYard) {
            var authData = common.localStorageService.get('authorizationData');
            var currentYard = $(vm.yardInfo).filter(function (a, b) { return b.currentYard == "currentYard"; })[0];
            if (currentYard.code != newYard) {
                var RolesByUserQuery = common.localStorageService.get('GetRolesByUserQuery');
                $.ajax({
                    async: false,
                    headers: {
                        'Authorization': 'Bearer ' + authData.access_token,
                        "ModelRequester": JSON.stringify(authData.ModelRequester)
                    },
                    url: common.config.basePaths.Base_Path_Resources + 'Appointment/changeBPyard?GroupCode=' + newYard + '&userName=' + authData.username + '&securityRole=' + RolesByUserQuery.code + '&fromLoginWindow=' + common.localStorageService.get('fromLoginWindow'),
                    type: "GET",
                    success: function (moveYardResult) {
                        if (moveYardResult) {
                            var moveYard = moveYardResult.Yard;
                            if (moveYard != null) {
                                //update current yard
                                $(vm.yardInfo).each(function (i, j) {
                                    if (j.code == moveYard.Code)
                                        j.currentYard = "currentYard";
                                    else
                                        j.currentYard = "";
                                });

                                if (common.localStorageService.get('selectedYard') != null)
                                    common.localStorageService.set('selectedYard', null);

                                authData.ModelRequester.CurrentYardId = moveYard.YardId;
                                common.localStorageService.set('yardList', vm.yardInfo);

                                common.localStorageService.set('authorizationData', authData);
                                setUserData();
                                $state.reload();
                            }
                        }
                    },
                    error: function () {
                        toastr.error("Se produjo un error");
                    }
                });
            }

        }

        function setUserData() {
            //set current user name
            var authData = common.localStorageService.get('authorizationData');
            if (authData != null && authData != undefined)
                $('#currentUserName').html(authData.fullname);

            //set current yard
            var dataYards = common.localStorageService.get('yardList');
            if (dataYards) {
                vm.yardInfo = dataYards;
                var currentYard = $(dataYards).filter(function (a, b) { return b.currentYard == "currentYard"; })[0];
                if (currentYard) {
                    //set yard name
                    $('#currentYardName').html(currentYard.name);

                    //set style current yard
                    if ($('.yardItem').length > 0) {
                        $('.yardItem').removeClass('currentYard');
                        $($($('.yardItem').filter(function (a, b) {
                            return $(b).attr('data-yardname') == currentYard.code;
                        }))[0]).addClass('currentYard');
                    }


                }
            }
        }

        function getBooksOnLine() {
            return common.httpPostFile(common.config.basePaths.Base_Path_Resources + 'reportList/GetBooksOnLine', 
                { fileName : "TSS_Manual_de_Usuario_TransDepot_Portal_Web.pdf" }, 
                "TSS_Manual_de_Usuario_TransDepot_Portal_Web.pdf");
        }
        function getAlerts(){
            var dataYards = common.localStorageService.get('yardList');
            vm.yardInfo = dataYards;
            var currentYard = $(dataYards).filter(function (a, b) { return b.currentYard == "currentYard"; })[0];

            datacontext.security.getPortalAlerts(currentYard.code).then(function(response){
              showBlockingAlert(response);
            });
        }
        function showBlockingAlert(alerts) {
            var dataAlerts = common.localStorageService.get('alertsList') || [];
            var alertsToShow = alerts.filter(x => !dataAlerts.includes(x.Code));
      
            if (alertsToShow == null || alertsToShow.length == 0) return;
      
            $scope.alertsToShow = alertsToShow;
            exDialog.openMessage({
              scope: $scope,
              template: 'app/components/getalerts/getAlerts.html',
              width: '485px',
              beforeCloseCallback: function () {
                alertsToShow.forEach(msg => dontShowAlert(msg.Code));
              }
            });
        }

        function dontShowAlert(code){
            var dataAlerts = common.localStorageService.get('alertsList') || [];
            dataAlerts.push(code);
            common.localStorageService.set('alertsList', dataAlerts);
        }
    }

})();
